// /* eslint-disable react-hooks/exhaustive-deps */
// /* eslint-disable @typescript-eslint/no-unused-vars */
// import { IconX } from "@tabler/icons-react";
// import NormalSearch from "../../../components/common/NormalSearch";
// import { useFetchRouteDriversData } from "../../../apis/driverApis";
// import { useEffect, useState } from "react";
// import toast from "react-hot-toast";
// import { useAssignDriver } from "../../../apis/drsSwapApi";

// type SwapDriverModalProps = {
//   open: boolean;
//   onClose: () => void;
//   routeCode?: string;
//   drsSwapId: string;
//   refetch?: () => void;
// };

// const SwapDriverModal = ({
//   open,
//   onClose,
//   routeCode,
//   drsSwapId,
//   refetch,
// }: SwapDriverModalProps) => {
//   const {
//     data: routeDrivers,
//     isLoading,
//     isFetching,
//     refetch: refetchDrivers,
//   } = useFetchRouteDriversData(routeCode || "");

//   const assignDriver = useAssignDriver();
//   const [isAssigning, setIsAssigning] = useState(false);

//   const handleAssignDriver = async (driverId: string) => {
//     setIsAssigning(true);
//     assignDriver.mutate(
//       {
//         drsSwapId: drsSwapId,
//         driverId,
//       },
//       {
//         onSuccess: () => {
//           onClose();
//           refetch?.();
//         },
//         onError: (err: any) => {
//           toast(err.message || "Failed to assign driver");
//         },
//         onSettled: () => {
//           setIsAssigning(false);
//         },
//       }
//     );
//   };

//   useEffect(() => {
//     if (open && routeCode) {
//       refetchDrivers();
//     }
//   }, [open, routeCode, refetchDrivers]);

//   if (!open) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
//       <div className="bg-[#F7F6F2] rounded-3xl w-[500px] h-[63vh] flex flex-col overflow-hidden">
//         {/* Header */}
//         <div className="flex items-center justify-between px-4 py-3 border-b">
//           <h2 className="text-lg font-medium text-[#212121]">Swap Driver</h2>
//           <button
//             onClick={onClose}
//             className="p-2 rounded-full border border-[#D2D2D2]"
//           >
//             <IconX size={20} />
//           </button>
//         </div>

//         {/* Search */}
//         <div className="px-4 py-2">
//           <NormalSearch value="" onChange={() => {}} />
//         </div>

//         <div className="flex-1 overflow-y-auto hide-scrollbar px-4 py-2">
//           {isLoading || isFetching ? (
//             <div className="flex items-center justify-center h-full">
//               <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-[#212121]"></div>
//             </div>
//           ) : routeDrivers && routeDrivers.length > 0 ? (
//             <div className="space-y-2">
//               {routeDrivers.map((driver: any) => (
//                 <div
//                   key={driver.id}
//                   className="flex items-center py-1 justify-between"
//                 >
//                   <div className="flex items-center gap-2">
//                     <img
//                       src={driver.img || "/img/dummy-driver.png"}
//                       className="w-10 h-10 rounded-full object-cover"
//                       alt={driver.name}
//                     />
//                     <p className="text-[#000000] text-base font-normal">
//                       {driver.name}
//                     </p>
//                   </div>
//                   <button
//                     onClick={() =>
//                       !driver.assigned && handleAssignDriver(driver.id)
//                     }
//                     disabled={driver.assigned || isAssigning}
//                     className={`px-4 py-1 rounded-full border transition-colors relative ${
//                       driver.assigned
//                         ? "border-[#FF4848] hover:bg-[#FF4848]/10"
//                         : isAssigning
//                         ? "border-gray-400 cursor-wait"
//                         : "border-[#212121] hover:bg-gray-200"
//                     }`}
//                   >
//                     {isAssigning ? (
//                       <div className="flex items-center gap-1">
//                         <div className="w-4 h-4 border-2 border-gray-400 border-t-transparent rounded-full animate-spin"></div>
//                       </div>
//                     ) : (
//                       <img
//                         src={
//                           driver.assigned
//                             ? "/img/user-minus-icon.svg"
//                             : "/img/user-plus-icon.svg"
//                         }
//                         alt={driver.assigned ? "Remove" : "Add"}
//                         className="w-5 h-5"
//                       />
//                     )}
//                   </button>
//                 </div>
//               ))}
//             </div>
//           ) : (
//             <div className="flex flex-col items-center justify-center h-full text-gray-500">
//               <img
//                 src="/img/no-data.svg"
//                 alt="No drivers"
//                 className="w-20 h-20 mb-3 opacity-60"
//               />
//               <p className="text-base">No drivers found</p>
//               <p className="text-sm text-gray-400 mt-1">
//                 Try adjusting your search
//               </p>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SwapDriverModal;

/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { IconX } from "@tabler/icons-react";
import NormalSearch from "../../../components/common/NormalSearch";
import { useFetchRouteDriversData } from "../../../apis/driverApis";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useAssignDriver } from "../../../apis/drsSwapApi";
import { usePermission } from "../../../hooks/usePermissionTabs";
import { useFetchDRSSwapDriverRouteCodeList } from "../../../apis/swapGenerateApis";

type SwapDriverModalProps = {
  open: boolean;
  onClose: () => void;
  raiseReqDriverDriverRouteCode?: string;
  excludeDriverId?: string;
  drsSwapId: string;
  refetch?: () => void;
  isSidebar?: boolean;
  selectedLines?: string[];
};

const SwapDriverModal = ({
  open,
  onClose,
  raiseReqDriverDriverRouteCode,
  excludeDriverId,
  drsSwapId,
  refetch,
  isSidebar,
  selectedLines,
}: SwapDriverModalProps) => {
  const { allowed: canUpdateSwap } = usePermission("drs_swap", "update");
  const {
    data: routeDrivers,
    isLoading,
    isFetching,
    refetch: refetchDrivers,
  } = useFetchDRSSwapDriverRouteCodeList(
    raiseReqDriverDriverRouteCode || "",
    excludeDriverId,
  );

  const assignDriver = useAssignDriver();
  const [isAssigning, setIsAssigning] = useState(false);
  const [selectedDriverId, setSelectedDriverId] = useState<string | null>(null);

  // Sync selected driver from API data
  useEffect(() => {
    if (routeDrivers) {
      const assigned = routeDrivers.find((d: any) => d.assigned);
      setSelectedDriverId(assigned ? assigned.id : null);
    }
  }, [routeDrivers]);

  const [loadingDriverId, setLoadingDriverId] = useState<string | null>(null);

  const handleAssignDriver = async (driverId: string) => {
    if (!canUpdateSwap) {
      toast.error("You do not have permission to update swaps");
      return;
    }
    if (isAssigning) return;

    setLoadingDriverId(driverId);
    setIsAssigning(true);

    const shouldUnassign = selectedDriverId === driverId;

    assignDriver.mutate(
      {
        drsSwapId,
        driverId: shouldUnassign ? null : driverId,
        shipmentIds: selectedLines,
      },
      {
        onSuccess: () => {
          setSelectedDriverId(shouldUnassign ? null : driverId);
          toast.success(
            shouldUnassign
              ? "Driver Unassigned"
              : "Driver Assigned Successfully",
          );
          refetch?.();
          onClose();
        },
        onError: (err: any) => {
          toast.error(err.message || "Failed to update driver");
        },
        onSettled: () => {
          setIsAssigning(false);
          setLoadingDriverId(null); // ← Clear loading
        },
      },
    );
  };
  useEffect(() => {
    if (open && raiseReqDriverDriverRouteCode) {
      refetchDrivers();
    }
  }, [open, raiseReqDriverDriverRouteCode, refetchDrivers]);

  if (!open) return null;

  if (isSidebar) {
    return (
      <div className="w-full flex flex-col bg-white border border-[#E5E5E5] rounded-xl overflow-hidden shadow-sm">
        {/* Flat header */}
        <div className="flex items-center justify-between px-4 py-3 border-b border-[#E5E5E5] bg-white">
          <div>
            <h3 className="text-sm font-bold text-[#212121]">Assign Driver</h3>
            {raiseReqDriverDriverRouteCode && (
              <span className="text-[#212121]/70 font-medium text-xs">
                {" "}
                {raiseReqDriverDriverRouteCode}
              </span>
            )}
          </div>
          <button
            onClick={onClose}
            className="p-1.5 rounded-lg border border-[#D2D2D2]"
          >
            <IconX size={16} />
          </button>
        </div>

        {/* Driver list */}
        <div className="overflow-y-auto max-h-[60vh] custom-scrollbar divide-y divide-gray-100">
          {isLoading ? (
            <div className="flex items-center justify-center h-40">
              <div className="animate-spin rounded-full h-7 w-7 border-t-2 border-b-2 border-[#FBD037]"></div>
            </div>
          ) : routeDrivers && routeDrivers.length > 0 ? (
            routeDrivers.map((driver: any) => {
              const isSelected = selectedDriverId === driver.id;
              return (
                <div
                  key={driver.id}
                  className="flex items-center gap-3 px-4 py-3 hover:bg-gray-50 transition-colors"
                >
                  <img
                    src={
                      driver.image ||
                      driver.img ||
                      "/img/dummy-blank-profile.png"
                    }
                    onError={(e) => {
                      (e.target as HTMLImageElement).src =
                        "/img/dummy-blank-profile.png";
                    }}
                    className="w-9 h-9 rounded-full object-cover border border-gray-200 shrink-0"
                    alt={driver.name}
                  />
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold text-[#212121] truncate">
                      {driver.name}
                    </p>
                    {driver.routeCode && (
                      <p className="text-[11px] text-gray-400 font-medium">
                        {driver.routeCode}
                      </p>
                    )}
                  </div>
                  <button
                    onClick={() => handleAssignDriver(driver.id)}
                    disabled={isAssigning || !canUpdateSwap}
                    className={`shrink-0 px-3 py-1.5 rounded-lg border text-xs font-bold transition-all ${
                      isSelected
                        ? "border-rose-300 bg-rose-50 text-rose-600 hover:bg-rose-100"
                        : "border-[#FBD037] bg-[#FBD037]/10 text-[#212121] hover:bg-[#FBD037]/30"
                    } ${isAssigning ? "cursor-wait opacity-60" : "cursor-pointer"} ${!canUpdateSwap ? "opacity-50 cursor-not-allowed" : ""}`}
                  >
                    {loadingDriverId === driver.id ? (
                      <div className="w-3.5 h-3.5 border-2 border-current border-t-transparent rounded-full animate-spin mx-auto"></div>
                    ) : isSelected ? (
                      "Unassign"
                    ) : (
                      "Assign"
                    )}
                  </button>
                </div>
              );
            })
          ) : (
            <div className="flex flex-col items-center justify-center h-40 text-gray-400">
              <p className="text-sm font-medium">No drivers found</p>
              <p className="text-xs mt-1">
                for route {raiseReqDriverDriverRouteCode || "N/A"}
              </p>
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-[#F7F6F2] rounded-3xl w-[500px] h-[63vh] flex flex-col overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-3 border-b">
          <h2 className="text-lg font-medium text-[#212121]">Swap Driver</h2>
          <button
            onClick={onClose}
            className="p-1.5 rounded-full border border-[#D2D2D2]"
          >
            <IconX size={20} />
          </button>
        </div>

        {/* Search */}
        <div className="px-4 py-2">
          <NormalSearch value="" onChange={() => {}} />
        </div>

        <div className="flex-1 overflow-y-auto hide-scrollbar px-4 py-2">
          {isLoading ? (
            <div className="flex items-center justify-center h-full">
              <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-[#212121]"></div>
            </div>
          ) : routeDrivers && routeDrivers.length > 0 ? (
            <div className="space-y-2">
              {routeDrivers.map((driver: any) => {
                const isSelected = selectedDriverId === driver.id;

                return (
                  <div
                    key={driver.id}
                    className="flex items-center py-1 justify-between"
                  >
                    <div className="flex items-center gap-2">
                      <img
                        src={
                          driver.image ||
                          driver.img ||
                          "/img/dummy-blank-profile.png"
                        }
                        onError={(e) => {
                          (e.target as HTMLImageElement).src =
                            "/img/dummy-blank-profile.png";
                        }}
                        className="w-10 h-10 rounded-full object-cover"
                        alt={driver.name}
                      />
                      <p className="text-[#000000] text-base font-normal">
                        {driver.name}
                      </p>
                    </div>
                    <button
                      onClick={() => handleAssignDriver(driver.id)}
                      disabled={isAssigning || !canUpdateSwap}
                      className={`px-4 py-1 rounded-full border transition-all min-w-[40px]
                        ${
                          isSelected
                            ? "border-[#FF4848] bg-[#FF4848]/10 hover:bg-[#FF4848]/20"
                            : "border-[#212121] hover:bg-gray-200"
                        }
                        ${isAssigning ? "cursor-wait" : "cursor-pointer"}
                        ${!canUpdateSwap ? "opacity-50 cursor-not-allowed" : ""}
                      `}
                    >
                      {loadingDriverId === driver.id ? (
                        <div className="w-4 h-4 border-2 border-gray-400 border-t-transparent rounded-full animate-spin mx-auto"></div>
                      ) : (
                        <img
                          src={
                            isSelected
                              ? "/img/user-minus-icon.svg"
                              : "/img/user-plus-icon.svg"
                          }
                          alt={isSelected ? "Unassign" : "Assign"}
                          className="w-5 h-5 mx-auto"
                        />
                      )}
                    </button>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center h-full text-gray-500">
              <img
                src="/img/no-data.svg"
                alt="No drivers"
                className="w-20 h-20 mb-3 opacity-60"
              />
              <p className="text-base">No drivers found</p>
              <p className="text-sm text-gray-400 mt-1">
                Try adjusting your search
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SwapDriverModal;
